<app-security-section>
  <mat-card>
    <mat-card-title class="header">
      <h2 mat-dialog-title *ngIf="securityRoleId" appLocalizationPopupDirective localizationCode="EditSecurityRole">{{ 'EditSecurityRole' | translate: {Default: "Edit Security Role"} }}</h2>
      <h2 mat-dialog-title *ngIf="!securityRoleId" appLocalizationPopupDirective localizationCode="CreateASecurityRole">{{ 'CreateASecurityRole' | translate: {Default: "Create a Security Role"} }}</h2>

      <div class="buttons-container">
        <button mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="copySecurityRole()" *ngIf="securityRoleId">
          <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">copy</mat-icon>
          {{ 'Copy' | translate: {Default: "Copy"} }}
        </button>
        <button mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="deleteSecurityRole()" *ngIf="securityRoleId">
          <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">delete</mat-icon>
          {{ 'Delete' | translate: {Default: "Delete"} }}
        </button>
        <button mat-raised-button appPreventDoubleClick (throttledClick)="navigateToSecurityRoles()">{{ 'Close' | translate: {Default: "Close"} }}</button>
        <button 
          mat-raised-button 
          setColor="primaryColour" 
          color="primary" 
          appPreventDoubleClick 
          (throttledClick)="getFormData = !getFormData" 
          [disabled]="!formValid">Save</button>
      </div>
    </mat-card-title>
    <mat-card-content>
      <div class="container" *ngIf="!isLoading else loading">
        <div class="left">
          <app-form-generator
              [formId]="formId"
              [formData]="formData"
              [emitFormDataTrigger]="getFormData"
              (emitFormData)="formDataEmitted($event)"
              (emitFormStatus)="formStatusUpdated($event)"
              (emitFormPristine)="formPristineEmitted($event)"
            ></app-form-generator>

          <div class="">
            <div class="form-section-title">
                <h6 appLocalizationPopupDirective localizationCode="Features">
                    {{ 'Features' | translate: {Default: "Features"} }}
                </h6>
            </div>

            <div class="tree-controls" appLocalizationPopupDirective localizationCode="FeaturesSearch">
              <form [formGroup]="treeFilterForm">
                <mat-form-field appearance="fill" class="tree-search-field">
                  <mat-label>{{ 'SearchFeatures' | translate: {Default: "Search Features"} }}</mat-label>
                  <input matInput type="text" formControlName="treeFilter" (input)="filterTree()" placeholder="{{ 'Search' | translate: {Default: 'Search'} }}">
                  <button mat-icon-button matSuffix *ngIf="treeFilterForm.get('treeFilter')?.value" appPreventDoubleClick (throttledClick)="treeFilterForm.get('treeFilter').setValue(''); filterTree()">
                    <mat-icon class="material-icons-outlined">close</mat-icon>
                  </button>
                </mat-form-field>
              </form>
  
              <div class="tree-controls-buttons">
                <button mat-stroked-button appPreventDoubleClick (throttledClick)="treeControl.expandAll()" appLocalizationPopupDirective localizationCode="ExpandAll">
                  <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">expand_more</mat-icon>
                  {{ 'ExpandAll' | translate: {Default: "Expand All"} }}
                </button>
                <button mat-stroked-button appPreventDoubleClick (throttledClick)="treeControl.collapseAll()" appLocalizationPopupDirective localizationCode="CollapseAll">
                  <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">expand_less</mat-icon>
                  {{ 'CollapseAll' | translate: {Default: "Collapse All"} }}
                </button>
              </div>
            </div>

            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                <button mat-icon-button disabled></button>
                <mat-checkbox class="checklist-leaf-node"
                              [checked]="checklistSelection.isSelected(node)"
                              (change)="checklistSelection.toggle(node); toggleAllParentsSelection(node)">{{node.name}}</mat-checkbox>
              </mat-tree-node>

              <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'toggle ' + node.filename">
                  <mat-icon class="material-icons-outlined mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <mat-checkbox [checked]="checklistSelection.isSelected(node)"
                              [indeterminate]="descendantsPartiallySelected(node)"
                              (change)="featureItemSelectionToggle(node); toggleAllParentsSelection(node)">{{node.name}}</mat-checkbox>
              </mat-tree-node>
            </mat-tree>
          </div>
        </div>

        <div class="right">
          <div class="k-d-flex-row">
            <div class="grid-container k-d-flex-col k-mb-3 k-pb-3 k-mx-6" *ngIf="securityRoleId && (securityRole.id !== 'rle_Employee' && securityRole.id !== 'rle_Manager')">
              <app-module-access-by-organization
                class="k-ml-6"
                [securityRoleId]="securityRoleId"
              ></app-module-access-by-organization>

              <app-users-in-role
                class="k-ml-6"
                [securityRoleId]="securityRoleId"
              ></app-users-in-role>
            </div>
          </div>
        </div>
      </div>
      <ng-template #loading>
        <div class="loading-container">
          <ngx-skeleton-loader count="5" [theme]="{ 'height.px': 30}"></ngx-skeleton-loader>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</app-security-section>
